export class NativeStreamTransformProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "compileErrors",
            "baseName": "compileErrors",
            "type": "Array<NativeStreamProbeIssue>",
            "format": ""
        },
        {
            "name": "sourceColumns",
            "baseName": "sourceColumns",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "effectiveColumns",
            "baseName": "effectiveColumns",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "outputColumns",
            "baseName": "outputColumns",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "derivedColumns",
            "baseName": "derivedColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "transientColumns",
            "baseName": "transientColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "gatedOutColumns",
            "baseName": "gatedOutColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        },
        {
            "name": "rowErrors",
            "baseName": "rowErrors",
            "type": "Array<NativeStreamProbeIssue>",
            "format": ""
        },
        {
            "name": "sampling",
            "baseName": "sampling",
            "type": "NativeStreamProbeSamplingReport",
            "format": ""
        },
        {
            "name": "filter",
            "baseName": "filter",
            "type": "NativeStreamProbeFilterReport",
            "format": ""
        },
        {
            "name": "warnings",
            "baseName": "warnings",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
